const toggle = () => {
	let body = document.getElementsByTagName('body')[0];
	let map = document.getElementById('property-map');
	let button = document.getElementById('map-button');
	button.onclick = () => {
		if ( map.style.visibility === 'hidden' ) {
			body.classList.add('is-active-map');
			map.style.visibility = 'visible';
			button.innerHTML = 'Close';
		} else {
			body.classList.remove('is-active-map');
			map.style.visibility= 'hidden';
			button.innerHTML = 'Map';
		}
	}
}

export default {
	toggle
}
